/**
 * 自定义指令集 v-xxxxx
 */
import {
  Message
} from 'element-ui'

/**
 * 复制v-copy
 */
export const copy = {
  bind(el, {
    value
  }) {
    el.$value = value;
    el.$handler = function() {
      if (!el.$value) {
        Message.error('复制成功')
        return
      }
      const textarea = document.createElement('textarea');
      textarea.readOnly = 'readonly';
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      textarea.value = el.$value;
      document.body.appendChild(textarea)
      textarea.select();
      const result = document.execCommand('Copy');
      if (result) {
        Message.success('复制成功')
      }
      document.body.removeChild(textarea)
    }
    el.addEventListener('click', el.$handler)
  },
  componentUpdated(el, {
    value
  }) {
    el.$value = value;
  },
  unbind(el) {
    el.removeEventListener('click', el.$handler)
  }
}

/**
 * 防抖 v-debounce
 */
export const debounce = {
  inserted(el, binding) {
    let timer,
      timeout = 500;
    if (binding.arg && !isNaN(binding.arg)) {
      timeout = binding.arg || 500;
    }
    el.addEventListener('click', () => {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        binding.value()
      }, timeout)
    })
  }
}

/**
 * 页面滚动指令
 */
export const scrollTo = {
  bind(el, {
    value
  }) {
    if (!value) {
      value = 'app-main'
    }
    el.$handler = function() {
      document.getElementsByClassName(value) && document.getElementsByClassName(value)[0].scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }
    el.addEventListener('click', el.$handler)
  },
  unbind(el) {
    el.removeEventListener('click', el.$handler)
  }
}

export const observe = {
  bind(el, binding) {
    let obFn; //绑定事件前确认好执行函数 防止函数中使用绑定前的参数 形成闭包
    if (binding.arg == 'call') {
      // 满足条件后不解除绑定
      obFn = ([{
        isIntersecting
      }]) => {
        binding.value && binding.value(isIntersecting, function() {
          ob.unobserve(el)
        },el)
      }
    } else {
      // 满足条件后直接解除绑定
      obFn = ([{
        isIntersecting
      }]) => {
        if (isIntersecting) {
          ob.unobserve(el)
          binding.value && binding.value(isIntersecting, function() {
            ob.unobserve(el)
          },el)
        }
      }
    }
    const ob = new IntersectionObserver(obFn)
    ob.observe(el)
    el.$observe = ob;
  },
  unbind(el) {
    el.$observe.unobserve(el)
  },
}
